import { render, staticRenderFns } from "./ModalHierarquia.vue?vue&type=template&id=1f560d6d&scoped=true"
import script from "./ModalHierarquia.vue?vue&type=script&lang=js"
export * from "./ModalHierarquia.vue?vue&type=script&lang=js"
import style0 from "./ModalHierarquia.vue?vue&type=style&index=0&id=1f560d6d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f560d6d",
  null
  
)

export default component.exports